import { useMemo } from 'react';
import { LikeDislikeTags } from '@hungryroot/rest';
import { useCustomerTags } from './useCustomerTags';
import { useFoodProfileRatableTagIds } from './useFoodProfileRatableTagIds';

export function useNeveredTagIds(
  options: { enabled?: boolean } = {}
): Set<number> {
  const isEnabled = options.enabled !== false;
  const allTagIds = useFoodProfileRatableTagIds({ enabled: isEnabled });
  const { data: allPrefs } = useCustomerTags(
    allTagIds.length > 0 ? allTagIds : undefined,
    { enabled: isEnabled }
  );

  return useMemo(() => {
    const preferences = allPrefs?.results || [];
    if (!preferences.length) return new Set<number>();
    const ids = preferences
      .filter((p) => p.preference === LikeDislikeTags.Disliked)
      .map((p) => p.tag);
    return new Set<number>(ids);
  }, [allPrefs?.results]);
}
